import PropTypes from "prop-types";

import React, { useState, useEffect } from "react";

import "./style.scss";

const SubmitSpinner = (props) => {
  const [spinPosition, setSpinPosition] = useState(-1);

  const renderSpin = () => {
    var prevSpin = spinPosition == -1 ? 0 : spinPosition;
    var nextSpin = ((prevSpin - 1 + 1) % 3) + 1;
    setSpinPosition(nextSpin);
  };

  useEffect(() => {
    if (spinPosition == -1) {
      renderSpin();
    }
  });

  useEffect(() => {
    setTimeout(function () {
      renderSpin();
    }, 1000 / 3);
  }, [spinPosition]);

  return (
    <div className={`SubmitSpinner`}>
      <div
        className={`spinner-dot dot-01 ${spinPosition == 1 ? "active" : ""}`}
      ></div>
      <div
        className={`spinner-dot dot-02 ${spinPosition == 2 ? "active" : ""}`}
      ></div>
      <div
        className={`spinner-dot dot-03 ${spinPosition == 3 ? "active" : ""}`}
      ></div>
    </div>
  );
};

SubmitSpinner.propTypes = {
  //
};

export default SubmitSpinner;
